import { MouseEvent, useCallback, useState } from 'react';
import { AccordionProps } from '../Accordion';

export interface UseAccordionGroup {
  /** @default 'single' */
  mode?: 'single' | 'multiple';
}

const useAccordionGroup = ({ mode = 'single' }: UseAccordionGroup) => {
  const [openAccordions, setOpenAccordions] = useState<string[]>([]);

  const getIsOpen = useCallback(
    (identifier: string) => openAccordions.includes(identifier),
    [openAccordions]
  );

  const toggleOpen = useCallback(
    (identifier: string, onClick?: AccordionProps['onClick']) => (e: MouseEvent<HTMLElement>) => {
      onClick?.(e);
      setOpenAccordions((prevVal) => {
        const isOpen = prevVal.includes(identifier);
        if (isOpen) {
          return prevVal.filter((id) => id !== identifier);
        }
        if (mode === 'single') {
          return [identifier];
        }
        return [...prevVal, identifier];
      });
    },
    [mode]
  );

  return { getIsOpen, toggleOpen };
};

export default useAccordionGroup;
